import { Component, OnInit } from '@angular/core';
import { ModalService } from '@aft/frogo-kit/services/modal.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as FormHelpers from './../../core/utils/form-validator.helpers';
import { ActionsSubject, Store } from '@ngrx/store';
import * as AuthActions from '../../auth/store/actions/auth.actions';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ofType } from '@ngrx/effects';

@UntilDestroy()
@Component({
    selector: 'aft-change-password',
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss',
    standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  public title: string = '';
  public changePasswordForm: FormGroup = this._fb.group({
    oldPassword: ['', Validators.required],
    password: ['', [
      Validators.required,
      Validators.minLength(8),
      FormHelpers.patternValidator(/\d/, { hasNumber: true }),
      FormHelpers.patternValidator(/[a-z]/, { hasLowerLetters: true }),
      FormHelpers.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      FormHelpers.patternValidator(/[!@#\$%\^\&*\)\(+=._-]/, { hasSpecialCharacter: true }),
    ]],
    confirmPassword: ['', [Validators.required]],
  }, {
    validators: [
      FormHelpers.passwordMatchValidator,
    ],
  });

  public errorMessagesConfig = {
    minlength: () => this._translate.instant('auth.change-password.rules.rule1'),
    hasNumber: () => this._translate.instant('auth.change-password.rules.rule3'),
    hasLowerLetters: () => this._translate.instant('auth.change-password.rules.rule6'),
    hasCapitalCase: () => this._translate.instant('auth.change-password.rules.rule2'),
    hasSpecialCharacter: () => this._translate.instant('auth.change-password.rules.rule4'),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    NoPasswordMatch: () => this._translate.instant('auth.change-password.rules.rule5'),
  }

  public showPasswordOldPassword = false;
  public showPassword = false;
  public showPasswordRepeatPassword = false;

  constructor(
    private readonly _modal: ModalService,
    private readonly _fb: FormBuilder,
    private readonly _store: Store,
    private readonly _translate: TranslateService,
    private _actionsStream: ActionsSubject,
  ) {}

  public ngOnInit(): void {
    this._initSubs();
  }

  public onCloseModal() {
    this._modal.hide();
  }

  public updatePassword(): void {
    if (this.changePasswordForm.valid) {
      this._store.dispatch(AuthActions.requestPasswordChange({
        oldPassword: this.changePasswordForm.get('oldPassword').value,
        newPassword: this.changePasswordForm.get('password').value,
      }));
    }
  }

  private _initSubs(): void {
    this._actionsStream
      .pipe(
        untilDestroyed(this),
        ofType(AuthActions.requestPasswordChangeSuccess),
      )
      .subscribe(() => {
        this._modal.hide();
      });
  }
}
